"use client";

import Footer from "../global/partials/Footer";
import HeaderV2 from "../global/partials/HeaderV2";
import BirthdayTopBanner from "../global/BirthdayTopBanner";
import BirthdayPopUp from "../global/BirthdayPopUp";
import EcommerceHeader from "../pageComponents/ecommerce/EcommerceHeader";
import EcommerceNav from "../pageComponents/ecommerce/EcommerceNav";
import HeroSection from "../pageComponents/ecommerce/HeroSection";
import ComparisonSection from "../pageComponents/ecommerce/ComparisonSection";
import RulesSection from "../pageComponents/ecommerce/RulesSection";
import TeamSection from "../pageComponents/home/TeamSection";
import ProcessSection from "../pageComponents/ecommerce/ProcessSection";
import LivePayoutsSection from "../pageComponents/global/sections/LivePayoutsSection";
import VsTableSection from "../pageComponents/ecommerce/VsTableSection";
import TestimonialsSectionV2 from "../pageComponents/global/sections/TestimonialsSectionV2";
import FounderSection from "../pageComponents/ecommerce/FounderSection";
import KeyStatsSection from "../pageComponents/global/sections/KeyStatsSection";
import ScrollingBanner from "../pageComponents/global/ScrollingBanner";
import { PageHomeSchema } from "@/sanity/pages/PageHomeTemplate";
import { PageEcommerceSchema } from "@/sanity/pages/PageEcommerceTemplate";

export default function PageEcommerceJSX({
  data,
}: {
  data: PageEcommerceSchema;
}) {
  return (
    <>
      <EcommerceHeader data={data} className="block" />
      {/*<EcommerceNav data={data} />*/}
      <HeroSection data={data} />
      <ScrollingBanner
        className="bg-[#f4f5f5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />
      <ComparisonSection data={data} />
      <TeamSection
        data={data as unknown as PageHomeSchema}
        language={data.settings?.language}
        showPartnersLogos
        partnersLogos={data.heroEndorserLogos}
        className="pt-[7rem]"
      />

      <RulesSection data={data} />
      <ProcessSection data={data} />
      <LivePayoutsSection data={data as unknown as PageHomeSchema} hideCta />
      <VsTableSection data={data} />
      <TestimonialsSectionV2
        theme="light"
        language={data.settings?.language}
        data={{
          ...data,
          testimonialsCards: data.testimonialsCardsRef,
        }}
      />

      <FounderSection data={data} />
      <KeyStatsSection
        data={{ items: data.keyStatsItems }}
        className="bg-white"
      />
      <ScrollingBanner
        className="bg-[#f4f5f5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />
      {data?.settings?.footer && <Footer data={data.settings.footer} finalCta={data} language={data?.settings?.language} />}
    </>
  );
}
